export default ({deposits}) => {
    return (
        <div className="level">
            <div className="top">
                <div className="amount">
                    <span>${deposits.toFixed(2)}</span>
                    Deposits in 14 days
                </div>
                <div className="lore">
                    <span className="bronze">Bronze</span>
                    Vip Level
                </div>
            </div>
            <div className="benefits">
                <div></div>
                <span>MY BENEFITS</span>
                <div></div>
            </div>
            <div className="benefits-list" data-benefits="1">
                <div className="benefit">
                    <div className="emoji">
                        💰
                    </div>
                    <div className="details">
                        <div className="name">Cashback</div>
                        <div className="value">2%</div>
                    </div>
                </div>
            </div>
        </div>
    )
}